import { render, staticRenderFns } from "./Remove2FASuccess.vue?vue&type=template&id=10a75dea&"
import script from "./Remove2FASuccess.vue?vue&type=script&lang=js&"
export * from "./Remove2FASuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports